import { render, staticRenderFns } from "./WinsCustomerInfo.vue?vue&type=template&id=71d05cbe&"
import script from "./WinsCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./WinsCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./WinsCustomerInfo.vue?vue&type=style&index=0&id=71d05cbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports